module.exports = __webpack_public_path__ + "27f4369da275dd760ae34f272e31fb2b.MP3";